<autocomplete-list-item (clicked)="triggerEvent()">
  <div class="header">{{ item.titleShort }} {{ item.firstName }} {{ item.lastName }}</div>
  <div *ngIf="item.institution">{{ item.institution.description }}</div>
  <div>{{ item.department }}</div>
  <div>{{ item.address }}</div>
  <div>{{ item.postalCode }} {{ item.city }}</div>
  <div>{{ item.customerId }}</div>
</autocomplete-list-item>
